// extracted by mini-css-extract-plugin
module.exports = {"welcomeBack":"_3UBfF","continueButton":"_2uKtH"};